module.exports = __webpack_public_path__ + "img/selected1-min.47f08260.png";